import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import { getLng } from './getLng'

import translation_zh_CN from "@/locales/zh_CN.json";
import translation_zh from "@/locales/zh.json";
import translation_en from "@/locales/en.json";
import translation_ja from "@/locales/ja.json";
import translation_ko from "@/locales/ko.json";
import translation_vi from "@/locales/vi.json";
import translation_de from "@/locales/de.json";
import translation_es from "@/locales/es.json";
import translation_fr from "@/locales/fr.json";
import translation_pt from "@/locales/pt.json";
import translation_tr from "@/locales/tr.json";
import translation_ar from "@/locales/ar.json";
import translation_ru from "@/locales/ru.json";

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
    zh_CN: {
        translation: translation_zh_CN
    },
    zh: {
        translation: translation_zh
    },
    en: {
        translation: translation_en
    },
    ja: {
        translation: translation_ja
    },
    ko: {
        translation: translation_ko
    },
    vi: {
        translation: translation_vi
    },
    de: {
        translation: translation_de
    },
    es: {
        translation: translation_es
    },
    fr: {
        translation: translation_fr
    },
    pt: {
        translation: translation_pt
    },
    tr: {
        translation: translation_tr
    },
    ar: {
        translation: translation_ar
    },
    ru: {
        translation: translation_ru
    }
};



i18n
    .use(initReactI18next) // passes i18n down to react-i18next
    .init({
        resources,
        lng: getLng(), // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
        // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
        // if you're using a language detector, do not define the lng option

        interpolation: {
            escapeValue: false // react already safes from xss
        }
    });

export default i18n;